import React, { useEffect } from 'react';
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import './globals.css'; // or About.css if you prefer

const About = () => {
  useEffect(() => {
    document.title = "IWPFI2026_About";
  }, []);
  return (
    <div id="everything">
      <NavigationBar />

      <main className="page-about">
        {/* Intro / overview */}
        <section className="about-section">
          <h1 className="about-title">About the Conference</h1>

          <h2 className="about-subtitle">
            Join us in Mont-Tremblant! – September 23–25, 2026
          </h2>
          <h2 className="about-subtitle">
            Venue: Fairmont Tremblant
          </h2>
          
          {/* Button link */}
          {/* <div className="reg-button-wrapper">
            <a 
              href="https://www.fairmont.com/tremblant/#" 
              target="_blank" 
              rel="noopener noreferrer"
              className="reg-button"
            >
              Fairmont Tremblant Website
            </a>
          </div> */}

          <p>
            The 12th International Workshop for Pulmonary Functional Imaging (IWPFI 2026) is a premier opportunity
            to share new insights, reconnect with colleagues, and explore advances in pulmonary imaging that drive
            better patient outcomes.
          </p>

          <p>
            Held for the first time in Canada, IWPFI 2026 will gather leading experts, researchers, and trainees
            from around the world to discuss cutting-edge imaging biomarkers, emerging therapies, and innovations
            transforming the understanding of lung structure and function.
          </p>

          <p>
            This biennial workshop fosters collaboration across disciplines and celebrates excellence through the
            John West Gold Medal and the Gefter–Hatabu Young Investigator Award, continuing a proud tradition of
            advancing pulmonary functional imaging.
          </p>
        </section>

        {/* Conference features */}
        <section className="about-section">
          <h2>Conference features</h2>
          <ul className="about-list">
            <li>Welcome Reception</li>
            <li>Keynote plenaries</li>
            <li>Daily networking experiences</li>
            <li>President’s Gala on Friday (ticket purchase required)</li>
          </ul>
        </section>

        {/* Committees */}
        <section className="about-section">
          {/* <h2>Conference committees</h2> */}

          <div className="committee-grid">
            <div className="committee-card">
              <div className="committee-role">SCIENTIFIC PLANNING COMMITTEE</div>
              {/* <h3 className="committee-title">President and Chair</h3> */}
              <ul className="about-list">
                <li>Dr. Grace Parraga (President)</li>
                <li>Dr. Narinder Paul (Co-Chair)</li>
                <li>Dr. Miranda Kirby</li>
                <li>Dr. David Levin</li>
                <li>Dr. J Michael Nicholson</li>
                <li>Dr. Mark Schiebler</li>
                <li>Dr. Sarah Svenningsen</li>
                <li>Eveline Durom</li>
              </ul>
              <br></br>
              <div className="committee-role">CONFERENCE MANAGER</div>
              <ul className="about-list">
                <li>Chantal Goddard</li>
              </ul>
              
              {/* <h3 className="committee-title">Co-Chair</h3>
              <ul className="about-list">
                <li>Dr. Narinder Paul</li>
              </ul> */}
            </div>
            {/* <div className="committee-card">
              <div className="committee-role">Planning Committee</div>
              <h3 className="committee-title">Co-Chair</h3>
              <ul className="about-list">
                <li>Dr. Narinder Paul</li>
              </ul>
            </div> */}

            {/* <div className="committee-card">
              <div className="committee-role">Local Organizing Committee</div>
              <h3 className="committee-title">Members</h3>
              <ul className="about-list">
                <li>Dr. Sarah Svenningsen</li>
                <li>Dr. Miranda Kirby</li>
              </ul>
            </div>

            <div className="committee-card">
              <div className="committee-role">International Organizing Committee</div>
              <h3 className="committee-title">Members</h3>
              <ul className="about-list">
                <li>Dr. Mark Schiebler</li>
                <li>Dr. Jens Vogel-Claussen</li>
                <li>Dr. David Lewis Levin</li>
                <li>Dr. Yasutaka Nakano</li>
                <li>Dr. Hiroto Hatabu</li>
                <li>Dr. Jim Wild</li>
              </ul>
            </div> */}
          </div>
        </section>
        <div className="footer-logo">
          <img src="/images/iwpfi_horizontal_logo.jpg" alt="Logo" />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default About;
